/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/

(function () {

	// Below are example event listeners.  They listen for theme events that Pipeline
	// fires in order to make it easier for you to add customizations.

	// Keep your scripts inside this IIFE function call to avoid leaking your
	// variables into the global scope.


	// document.addEventListener('theme:variant:change', function(event) {
	//   // You might use something like this to write a pre-order feature or a
	//   // custom swatch feature.
	//   var variant = event.detail.variant;
	//   var container = event.target;
	//   if (variant) {
	//     console.log('Container ———————— ↓');
	//     console.log(container);
	//     console.log('Variant —————————— ↓');
	//     console.log(variant);
	//     // ... update some element on the page
	//   }
	// });


  // Harris Current Variant Swapper
  // var Shopify = Shopify || {};

  // Shopify.optionsMap = {};

  // Shopify.linkOptionSelectors = function(product, context) {

  //   Shopify.optionsMap[context] = {};
  //   // Building our mapping object.
  //   for (var i=0; i<product.variants.length; i++) {
  //     tempVariant = null;
  //     var variant = product.variants[i];
  //     // Gathering values for the 1st drop-down.
  //     if (variant.available) {
  //       Shopify.optionsMap[context]['root'] = Shopify.optionsMap[context]['root'] || [];
  //       Shopify.optionsMap[context]['root'].push(variant.option1);
  //       Shopify.optionsMap[context]['root'] = Shopify.uniq(Shopify.optionsMap[context]['root']);
  //       // Gathering values for the 2nd drop-down.
  //       if (product.options.length > 1) {
  //         var key = variant.option1;
  //         Shopify.optionsMap[context][key] = Shopify.optionsMap[context][key] || [];
  //         Shopify.optionsMap[context][key].push(variant.option2);
  //         Shopify.optionsMap[context][key] = Shopify.uniq(Shopify.optionsMap[context][key]);
  //       }
  //       // Gathering values for the 3rd drop-down.
  //       if (product.options.length === 3) {
  //         var key = variant.option1 + ' / ' + variant.option2;
  //         Shopify.optionsMap[context][key] = Shopify.optionsMap[context][key] || [];
  //         Shopify.optionsMap[context][key].push(variant.option3);
  //         Shopify.optionsMap[context][key] = Shopify.uniq(Shopify.optionsMap[context][key]);
  //       }
  //     }
  //   }
  
  //   // Update options right away.
  //   Shopify.updateOptionsInSelector(0, context, Shopify.optionsMap[context]);
  //   if (product.options.length > 1) Shopify.updateOptionsInSelector(1, context, Shopify.optionsMap[context]);
  //   if (product.options.length === 3) Shopify.updateOptionsInSelector(2, context, Shopify.optionsMap[context]);
  //   // When there is an update in the first dropdown.
  //   jQuery("[data-product-id='" + context + "'] .single-option-selector:eq(0)").change(function() {
  //     if (product.options.length > 1) Shopify.updateOptionsInSelector(1, context, Shopify.optionsMap[context]);
  //     if (product.options.length === 3) Shopify.updateOptionsInSelector(2, context, Shopify.optionsMap[context]);
  //     return true;
  //   });
  //   // When there is an update in the second dropdown.
  //   jQuery("[data-product-id='" + context + "'] .single-option-selector:eq(1)").change(function() {
  //     if (product.options.length === 3) Shopify.updateOptionsInSelector(2, context, Shopify.optionsMap[context]);
  //     return true;
  //   });
  
  // };
	



  function resetOptions(event) {
	if(event != null){
		const productElemJSON = document.querySelector('[data-product-json]');
	  let productJSONText
      if (productElemJSON) {
        productJSONText = productElemJSON.innerHTML;
      }
	  var prodJson = JSON.parse(productJSONText)
	  var sortedProd = prodJson.variants.sort((a,b)=>{
		return a.price - b.price
	  })
	  lowestProd = sortedProd[0]
	  var options = []
	  var j =0
	  if(prodJson.options[1] .indexOf('SIZE') > -1){options[0] = lowestProd.options[0]; options[2] = lowestProd.options[1]; options[1] = lowestProd.options[2]}
	  else{options = lowestProd.options}

	  var i = 0
	}
	
    $(".selector-wrapper").each(function(){ 
		if(event != null){
			var myElements = $(this).find(".radio__button input")
			
		
			for(const e of myElements){

				if(e.value == options[i]){
					// var myElement = e
				}
			}
			i++
		  var myFallback = $(this).find(".radio__button input:not(.unavailable)")[0];
		}else{ 
			var myElement = $(this).find(".radio__button input:not(.unavailable)")[0];
			var myFallback = $(this).find(".radio__button input")[0];
		}
		
      if (myElement) {
		
        myElement.click();
		if(event != null){
			// window.dispatchEvent(new CustomEvent('lowest:product:selected',  {
			// 	detail: {
			// 	  target:myElement,
			// 	}
			//   }))
		}
         //console.log("click");
      }
      else if(myFallback){
        // myFallback.click();
         //console.log("click fallback");
      }
      else{
        //console.log("can't click");
      }
    });
	
  }
  window.addEventListener('resetOptions', function(event){
	resetOptions(event)
	

  }
);

function set_option_reset_listener(){
	
	$(".selector-wrapper input").on('change', function() {
		if ( $(this).parents(".selector-wrapper").attr("data-option-position") === "1" ) {
			
				setTimeout(() => {
					let variantTitle = $('.product__title').text().toUpperCase()
					if(variantTitle.indexOf('GIFT CARD') > -1){return}
					resetOptions(null);
					
				  }, 300);
			
	
		  
		  // console.log("reset");
		}
	
		else{
		  // console.log("don't reset");
		}
	
	  })
	}

setTimeout(set_option_reset_listener, 1000)


$('.btn.product-quick-view').on('click', ()=>{
	setTimeout(set_option_reset_listener, 1000)

})

  document.addEventListener('theme:variant:change', function(event) {
	  // You might use something like this to write a pre-order feature or a
	  // custom swatch feature.\

	  var container = event.target
	  var variant = event.detail.variant;
	  const productElemJSON = document.querySelector('[data-product-json]');
	  let productJSONText
      if (productElemJSON) {
        productJSONText = productElemJSON.innerHTML;
      }
	  let prodJson = JSON.parse(productJSONText)
	  let newSel
	  if(event.detail.option != null){
		for(let i =0;i<prodJson.variants.length;i++){
			let val = event.detail.option.value
			if(prodJson.variants[i].option1.indexOf(val) > -1){
				variant = prodJson.variants[i]

				break
			}
		  }
	  }
	 
	  

	  // var container = event.target;
	  if (variant) {
	    // console.log('Container ———————— ↓');
	    // console.log(container);
	    // console.log('Variant —————————— ↓');
	    // console.log(variant);
	    // ... update some element on the page

      // Shopify.linkOptionSelectors(event.detail.product, event.detail.productId);
      
      $(".template-product #license-number").on("input", validateForm);
      validateForm();
		// console.log('current sku: '+variant.sku.toString())
      $(".current-sku").text(variant.sku);


      if ($(".variant__countdown strong").length) {
        $(".variant__countdown strong").text(inv_qty[ variant.id ]);
      }
      

      var savings = Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
      if (savings > 0) {
        $(".product__price .h4").addClass("product__price--sale");
        $(".product__price--discount-info").removeClass("hidden");
        $(".product__price--original").text("$"+variant.compare_at_price/100);
        $(".product__price--savings").text("You save "+ savings + "%");
      }
      else{
        $(".product__price .h4").removeClass("product__price--sale");
        $(".product__price--discount-info").addClass("hidden");
        $(".product__price--original").text("");
        $(".product__price--savings").text("");
      }


      $(".rr-item").hide();
      if ( $(".rr-item[data-variant-id='"+ variant.id +"']").length ) {
        $(".rr-item[data-variant-id='"+ variant.id +"']").show();
      }
      else{
        $(".rr-item.default").show();
      }
	  }
    else{
      $(".current-sku").text("N/A");
    }
	});

	// document.addEventListener('theme:cart:change', function(event) {
	//   var cart = event.detail.cart;
	//   if (cart) {
	//     console.log('Cart ———————————— ↓');
	//     console.log(cart);
	//     // ... update an app or a custom shipping caluclator
	//   }
	// });
	// Fired when page loads to update header values
	// document.addEventListener('theme:cart:init', (e) => {
	//   console.log('theme:cart:init');
	//   console.log(e);
	// });

	// Debounced scroll listeners.  Up and down only fire on direction changes
	// These events are useful for creating sticky elements and popups.
	// document.addEventListener('theme:scroll', e => { console.log(e); });
	// document.addEventListener('theme:scroll:up', e => { console.log(e); });
	// document.addEventListener('theme:scroll:down', e => { console.log(e); });

	// Debounced resize listener to bundle changes that trigger document reflow
	// document.addEventListener('theme:resize', e => { console.log(e); });

	// Locks and unlocks page scroll for modals and drawers
	// These are commented out because firing them will lock the page scroll
	// the lock event must set `detail` to the modal or drawer body so the 
	// scroll locking code knows what element should maintain scoll. 
	// document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
	// document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

	$(window).scroll(function () {
		if (window.scrollY == 0) {
			$('.product-add-popdown, #search-popdown').removeClass('hasScrolled');
		} else {
			$('.product-add-popdown, #search-popdown').addClass('hasScrolled');
		}
	});

	$(document).on('click', '.tab-link', function () {
		var tabIndex = $(this).data('tab');
		// console.log('tab: ', tabIndex);
		$(".tab-collection-link").hide();
		$(".tab-collection-link-" + tabIndex).fadeIn(1000);
	});

	const collection_card_sliders = document.querySelectorAll(".collection-card-slider");
	collection_card_sliders.forEach((section, i) => {
		//console.log(section)
		var section_id = $(section).data('section-id');
		init_collection_slider(section_id);
		//setTimeout(function(){ init_collection_slider(section_id) }, 500);
	});
	function init_collection_slider(section_id) {
		//console.log('section_id: ', section_id)

		$('.ccs-' + section_id).slick({
			speed: 400,
			dots: false,
			cssEase: 'cubic-bezier(0.165, 0.840, 0.440, 1.000)',
			touchThreshold: 10,
			slidesToShow: 3.2,
			slidesToScroll: 1,
			infinite: false,
			arrows: true,
      centerMode: false,
			// prevArrow: $('.csg-prev-' + section_id),
			// nextArrow: $('.csg-next-' + section_id),
			//variableWidth: true,
			//swipeToSlide: true,
			//swipe: false,
			responsive: [
				{
					breakpoint: 900,
					settings: {
						slidesToShow: 2.6,
					}
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 1.1
					}
				}
			]
		}).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
			// $(".csg-prev-" + section_id).removeClass('at-end')
			// $(".csg-next-" + section_id).removeClass('at-end')
			// if (currentSlide == 1 && nextSlide == 0) {
			// 	$(".csg-prev-" + section_id).addClass('at-end')
			// }
			// //console.log("sts", slick.$slides.length)
			// if (slick.$slides.length == (nextSlide + slick.options.slidesToShow)) {
			// 	$(".csg-next-" + section_id).addClass('at-end')
			// }

		});
	}

	$('.collection-card-link-slider').slick({
		speed: 700,
		dots: false,
		cssEase: 'cubic-bezier(0.165, 0.840, 0.440, 1.000)',
		slidesToShow: 3,
		slidesToScroll: 1,
		infinite: false,
		arrows: true,
		"prevArrow": $('.csl-prev'),
		"nextArrow": $('.csl-next'),
		responsive: [
			{
				breakpoint: 900,
				settings: {
					slidesToShow: 3,
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 1,
				}
			}
		]
	}).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
		$(".csl-prev").removeClass('at-end')
		$(".csl-next").removeClass('at-end')
		if (currentSlide == 1 && nextSlide == 0) {
			$(".csl-prev").addClass('at-end')
		}

		if (slick.$slides.length == (nextSlide + slick.options.slidesToShow)) {
			$(".csl-next").addClass('at-end')
		}

	});
	// Slick
	// if ($('.exmaple').length) {
	//   $('.exmaple').slick({
	//     infinite: true,
	//     slidesToShow: 1,
	//     slidesToScroll: 1,
	//     mobileFirst: true,
	//     autooplay: true,
	//     prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 12 20"> <path fill="#020202" d="M1.116 10.884a1.25 1.25 0 0 1 0-1.768l7.955-7.955A1.25 1.25 0 1 1 10.84 2.93L3.768 10l7.07 7.071a1.25 1.25 0 1 1-1.767 1.768l-7.955-7.955Zm1.765.366H2v-2.5h.881v2.5Z"/> </svg></button>',
	//     nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 12 20"> <path fill="#020202" d="M10.884 10.884a1.25 1.25 0 0 0 0-1.768L2.929 1.161A1.25 1.25 0 1 0 1.16 2.93L8.232 10l-7.07 7.071a1.25 1.25 0 1 0 1.767 1.768l7.955-7.955Zm-1.765.366H10v-2.5h-.881v2.5Z"/> </svg></button>',
	//     responsive: [
	//       {
	//         breakpoint: 900,
	//         settings: {
	//           slidesToShow: 3,
	//           arrows: false,
	//           variableWidth: true
	//         }
	//       }
	//     ]
	//   });
	// }

	// ^^ Keep your scripts inside this IIFE function call to avoid leaking your
	// variables into the global scope.




	/* Slick needs no get Reinitialized on window Resize after it was destroyed */
	$(window).on('load resize orientationchange', function () {
		// custom--section-icons .custom--section-logos
		$('.custom--section-icons .grid--slider-slick, .custom--section-logos .grid--slider-slick').each(function () {
			var $carousel = $(this);
			/* Initializes a slick carousel only on mobile screens */
			// slick on mobile
			if ($(window).width() > 599) {
				if ($carousel.hasClass('slick-initialized')) {
					$carousel.slick('unslick');
				}
			}
			else {
				if (!$carousel.hasClass('slick-initialized')) {
					$carousel.slick({
						arrows: false,
						slidesToShow: 1,
						dots: true,
            infinite: true
					});
				}
			}
		});


		// custom--section-columns
		$('.custom--section-columns .grid--slider-slick').each(function () {
			var $carousel = $(this);
			/* Initializes a slick carousel only on mobile screens */
			// slick on mobile
			if ($(window).width() > 599) {
				if ($carousel.hasClass('slick-initialized')) {
					// $carousel.slick('unslick');
				}
			}
			else {
				if (!$carousel.hasClass('slick-initialized')) {
					$carousel.slick({
						arrows: flase,
						slidesToShow: 1,
						dots: true,
						infinite: false
					});
				}
			}
		});
		$('.custom--section-columns .grid--slider-slick-desktop').each(function () {
			var $carousel = $(this);
			/* Initializes a slick carousel only on mobile screens */
			// slick on mobile
			if ($(window).width() > 599) {
        if (!$carousel.hasClass('slick-initialized')) {
          $carousel.slick({
            arrows: true,
            slidesToShow: 2,
            dots: true,
            // infinite: true
            infinite: false
          });
        }
			}
			else {
        if ($carousel.hasClass('slick-initialized')) {
          // $carousel.slick('unslick');
        }
      }
		});
	});

  $('.custom--section-collection-grid .grid').each(function () {
    var $carousel = $(this);
    /* Initializes a slick carousel only on mobile screens */
    // slick on mobile
    // if ($(window).width() > 599) {
    if ($(window).width() > 767) {
      if ($carousel.hasClass('slick-initialized')) {
        $carousel.slick('unslick');
      }
    }
    else {
      if (!$carousel.hasClass('slick-initialized')) {
        $carousel.slick({
          arrows: true,
          slidesToShow: 1,
          dots: true,
          infinite: false
        });
      }
    }
  });

  $('.custom--section-gallery .gallery.slider--mobile').each(function () {
    var $carousel = $(this);
    /* Initializes a slick carousel only on mobile screens */
    // slick on mobile
    if ($(window).width() > 599) {
    // if ($(window).width() > 767) {
      if ($carousel.hasClass('slick-initialized')) {
        $carousel.slick('unslick');
      }
    }
    else {
      if (!$carousel.hasClass('slick-initialized')) {
        $carousel.slick({
          arrows: true,
          slidesToShow: 1,
          dots: true,
          infinite: true
        });
      }
    }
  });



	$('.featured-collection-slider').slick({
		speed: 400,
		dots: false,
		cssEase: 'cubic-bezier(0.165, 0.840, 0.440, 1.000)',
		touchThreshold: 10,
		slidesToShow: 5.3,
		// slidesToScroll: 1,
		infinite: false,
		arrows: true,
		centerMode: false,
		responsive: [
			{
				breakpoint: 900,
				settings: {
					slidesToShow: 2.6,
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 1.1
				}
			}
		]
	});


	// Collection page Filters hide show bug fix 
	$('.collection__filters__toggle').click(function () {
		$('.collection__content, .collection__nav__buttons').toggleClass('filters-is-hidden');
		$('.collection__filters__wrapper').toggleClass('drawer--visible-hack')
	});
	// $('.collection__filters__toggle.filters--default-visible').click(function (e){
	// setTimeout(function (){
	// 	$(this).removeClass('filters--default-visible');
	// 	$('.collection__filters__wrapper').removeClass('drawer--visible');
	// }, 100)
	// });
	// $('.collection__filters__toggle:not(.filters--default-visible)').click(function (e){
	// 	setTimeout(function (){
	// 	$(this).addClass('drawer--visible');
	// 	$('.collection__filters__wrapper').addClass('drawer--visible');
	// }, 100)
	// });

	// product page | update variant sku in breadcrumb


	$('.show-variant-barcode--true .radio__button input').click(function () {
		// console.log($(this).data('variant-barcode'));
		$('.current-barcode').text($(this).data('variant-barcode'));
	});

	// Testimonial Sliders
	if ($('.custom--section-quotes .quotes-slider').length) {
		$('.custom--section-quotes .quotes-slider').slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			dots: true,
      autoplay: true,
      autoplaySpeed: 3500
		});
	}

	// Clean up white space in text. Shopify filters can only do so much... :-(
	var options = $('.collection-slider-grid .description *, .product-description *, .custom--collection-hero .collection__heading__text *, .shopify-policy__body *');
	for (index = 0; index < options.length; ++index) {
		options[index].innerHTML = options[index].innerHTML.replace(/\&nbsp;/g, '');
	}

	// open enxternal links in new tab
	var links = document.links;
	for (let i = 0, linksLength = links.length; i < linksLength; i++) {
		if (links[i].hostname !== window.location.hostname && !links[i].classList.contains("non-external")) {
			links[i].target = '_blank';
			links[i].rel = 'noreferrer noopener';
		}
	}

	// update cart number on cart page
	document.addEventListener('theme:cart:change', function(event) {
	  var cart = event.detail.cart;
	  if (cart) {
			let cart_count = cart.item_count
			if (cart_count == 1) {
				$('.general-title-count span').text(cart.item_count.toString() + " item");
			} else {
				$('.general-title-count span').text(cart.item_count.toString() + " items");
			}
	  }
	});

  if ( $("body#your-shopping-cart").length ) {
    setTimeout(() => {
      var radioOptions = document.querySelectorAll(".cart__footer__shipping-date .cart-radio span");
      var scheduleContainer = document.getElementById("scheduleContainer");
  
      radioOptions.forEach((option) => {
          const radioInput = option.querySelector("input[type='radio']");
          radioInput.addEventListener("change", function () {
              if (radioInput.checked) {
                  scheduleContainer.classList.toggle("hidden", radioInput.value !== "Schedule my shipment");
              }
          });
      });
      
    }, 300);
  }

	// focus on search dropdown when clicked
	$('.desktop-search').click(function (e){
		e.preventDefault();
		$('#search-popdown').addClass('is-visible');
		$('.search__predictive__main input[type="search"]').focus();
	});

	// search dropdown
	$('#searchLink').click(function (e) {
		e.preventDefault();
		setTimeout(function (){	
			$(".search__predictive__form__button").click();
		}, 100)
	});


  // $(".footer__title").click(function() {
  //   // $(this).next(".footer-quicklinks").toggleClass("active");
  //   $(this).toggleClass("active");
  // })

  // Blog Filter
  $(document).on('change', 'select.redirecter', function () {
    window.location = $(this).val();
  });

  function getProductName(){
    let params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });
    // Get the value of "some_key" in eg "https://example.com/?some_key=some_value"

    $("input[name='contact[name-of-product-youre-interested-in]']").val(params.product);
  }
  if ($("#item-inquiry").length) {
    getProductName();   
  }

  // <a href="#live-chat" onclick="LiveChatWidget.call('maximize');return false;">Send a message</a>
  // Trigger for opening live chat widget
  $("body").on("click", "a[href='#live-chat']", function () {
    LiveChatWidget.call('maximize');
  });






// OLD Quick Shop (Commented out for reference)

// 	$(document).on('click', '#shopify-section-custom-product-quick-shop .quantity__button', function(e) {
// 		e.preventDefault()
// 		var qty_input = $("#shopify-section-custom-product-quick-shop .quantity__input");
// 		var qty = parseInt(qty_input.val());
// 		if($(this).hasClass('quantity__button--plus')) {
// 				qty++;
// 		}else {
// 				if(qty > 1) {
// 						qty--;
// 				}
// 		}
// 		qty = (isNaN(qty))?1:qty;
// 		qty_input.val(qty);
// });

// 		$(document).on('click', '.btn--add-to-cart', function(e) {
// 				e.preventDefault();
// 				const form_id = $(this).data('form-id');
// 				//console.log('add to cart ...', form_id)
// 				$(".btn-state-ready").hide();
// 				$(".btn-state-loading").addClass('loading');
// 				addItem(form_id);
// 		});

// 		function addItem(form_id) {

// 				const data = $('#' + form_id).serialize()
// 				//console.log(data)
// 				$.ajax({
// 						type: 'POST',
// 						url: '/cart/add.js',
// 						dataType: 'json',
// 						data: data,
// 						success: function (data){
// 								//console.log('add to cart: ', data)
// 								setTimeout( function() {
// 										$(".btn-state-loading").removeClass('loading');
// 										$(".btn--add-to-cart").addClass('has-success');
// 								}, 1000 );

// 								getCart();
// 						},
// 						error: function (data){
// 								//console.log('add to cart ERR: ', data.responseJSON.description)
// 								$(".btn-state-loading").removeClass('loading');
// 								$(".btn-state-complete").html(data.responseJSON.message);
// 						}
// 				});
// 		}

// function getCart() {

// 		$.ajax({
// 				type: 'POST',
// 				url: '/cart.js',
// 				dataType: 'json',
// 				//data: data,
// 				success: function (data){
// 						//console.log('get cart: ', data)
// 						update_cart_count(data.item_count)
// 				},
// 				//error: addToCartFail
// 		});
// }

// function update_cart_count(new_count) {
// 				//console.log('new cart count: ', new_count);
// 		//need to connect this when the header is ready
// }

// const quick_shop_modal = $('#quick-shop-modal');
// const loader_html = '<div class="loader"><div></div></div>';

// $(document).on('click', '.open-quick-shop', function() {
// 		//console.log('open-quick-shop');
// 		resetQuickShop()
// 		var product_handle = $(this).data('product-handle');
// 		var product_collection = $(this).data('product-collection');

// 		if(!product_collection){
// 				product_collection = 'all';
// 		}
// 		$('body').css("overflow-y", "hidden") //prevent page scroll while modal is open
// 		getProduct(product_handle, product_collection)

// });
// $(document).on('click', '.action, .dialog__overlay', function() {
// 		//console.log('action')
// 		closeQuickShop();
// });

// $(document).on('keyup', function(e) {
// 		if (e.key == "Escape"){
// 				closeQuickShop();
// 		}
// });

// function closeQuickShop(){
// 		$('body').css("overflow-y", "scroll")
// 		quick_shop_modal.removeClass('dialog--open');
// 		quick_shop_modal.addClass('dialog--close');
// 		quick_shop_modal.find('.dialog__content').on('webkitAnimationEnd MSAnimationEnd oAnimationEnd animationend', function() {
// 				quick_shop_modal.removeClass('dialog--close');
// 		});
// }

// function getProduct(product_handle, product_collection){
// 		resetQuickShop();

// 		const vw = window.innerWidth;
// 		//console.log('VW: ', vw);
// 		var section = 'custom-product-quick-shop';
// 		if(vw <= 899){
// 				var section = 'custom-product-quick-shop-mobile';
// 		}
// 		const url = '/collections/'+product_collection+'/products/'+product_handle+'?sections='+section;


// 		$.ajax({
// 				type: 'GET',
// 				url: url, //use to pull completed snippet
// 				success: function (data){
// 						//console.log(url+' res: ', data);

// 						quick_shop_modal.addClass('dialog--open');
// 						populateQuickShop(data[section]);
// 						initSlider();

// 				},
// 				//error: Fail
// 		});
// }



// function populateQuickShop(product){
// 	$('.dialog__content', quick_shop_modal).html(product);
// 	$('.quick-shop-heading a').focus();
// }
// function resetQuickShop(){
// 	destroySlider();
// 	$('.dialog__content', quick_shop_modal).html(loader_html);
// }

// function initSlider() {
// 	//console.log('init slider')
// 	$('.quick-shop-image').slick({
// 			"infinite": true,
// 			"slidesToShow": 1,
// 			"slidesToScroll": 1,
// 			"prevArrow": $('.prev'),
// 			"nextArrow": $('.next'),
// 			"responsive": [
// 					{
// 							"breakpoint": 412,
// 							"settings": {
// 									"slidesToShow": 1,
// 									"slidesToScroll": 1,
// 							}
// 					}
// 			]
// 	});
// }
// function destroySlider(){
// 	//console.log('destroy slider')
// 	$('.quick-shop-image').slick('unslick');
// }

// End OLD Quick Shop


	
})();

// Check if #license-number is populated
function isLicenseNumberValid() {
  var licenseNumber = $(".template-product #license-number").val();
  // console.log("licenseNumber: " + licenseNumber);
  return licenseNumber !== "";
}

// Enable/disable the ATC button
function validateForm() {
  setTimeout(() => {
    var $submitButton = $(".template-product .product__submit__buttons button[type='submit']");
    $submitButton.prop("disabled", !isLicenseNumberValid());
  }, 100);
}


$(document).ready(function() {
  function addMarginBasedOnHeight() {
    var div = $('.secondary-img');
    var parentDiv = $('.custom--section-hero');
    var divHeight = div.height();
    var paddingBottom = divHeight / 2;
    parentDiv.css('padding-bottom', paddingBottom + 'px');
  }

  function checkViewportWidth() {
    var windowWidth = $(window).width();
    if (windowWidth <= 600) {
      addMarginBasedOnHeight();
    } else {
			$('.custom--section-hero').css('margin-bottom', 0 + 'px');
		}
		if (windowWidth > 600) {
			$('.custom--section-hero').css('padding-bottom', 0 + 'px');
		}
  }

  // Initial check
  checkViewportWidth();

  // Recalculate on window resize
  $(window).resize(function() {
    checkViewportWidth();
  });


  // Listen on .template-page
  setTimeout(() => {
    $(".template-product #license-number").on("input", validateForm);
  }, 300);

  // Validate on page load
  validateForm();
});

